import React from 'react'
import { View } from 'react-native'
import Svg, { Defs, LinearGradient, Stop, Text as SvgText } from 'react-native-svg'

import useTheme from '@common/hooks/useTheme'

import getStyles from './styles'

type Props = {
  width?: number
  height?: number
  withWrapper?: boolean
}

const AmbireLogo: React.FC<any> = ({ width = 74, height = 112, withWrapper }: Props) => {
  const { styles } = useTheme(getStyles)
  return (
    <View style={withWrapper ? styles.wrapper : {}}>
      <Svg
        width={withWrapper ? width - 4 : width}
        height={withWrapper ? height - 4 : height}
        viewBox="0 0 74 112"
      >
        <Defs>
          <LinearGradient id="zkx-grad" x1="0" y1="0" x2="0" y2="1">
            <Stop offset="0" stopColor="#AF50FF" />
            <Stop offset="1" stopColor="#6000FF" />
          </LinearGradient>
        </Defs>
        <SvgText
          x="37"
          y="72"
          textAnchor="middle"
          fontSize="48"
          fontWeight="900"
          fill="url(#zkx-grad)"
          fontFamily="System"
        >
          ZKX
        </SvgText>
      </Svg>
    </View>
  )
}

export default React.memo(AmbireLogo)
